// Server history and realtime carry the same UTC microsecond update revision.
// Keeping six digits avoids losing edits/deletions within one millisecond.
function revision(message) {
  const raw = message?.updated_at;
  if (typeof raw !== 'string') return null;
  const match = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d{1,6}))?Z$/.exec(raw);
  if (!match || !Number.isFinite(Date.parse(raw))) return null;
  return `${match[1]}.${(match[2] || '').padEnd(6, '0')}Z`;
}

export function newerMessage(existing, incoming) {
  if (!existing) return incoming;
  const oldVersion = revision(existing);
  const newVersion = revision(incoming);
  if (oldVersion && (!newVersion || oldVersion > newVersion)) return existing;
  return incoming;
}

export function reconcileHistory(history, current = []) {
  const messages = new Map();
  for (const message of [...history, ...current]) {
    const key = message.id ?? Symbol();
    messages.set(key, newerMessage(messages.get(key), message));
  }
  return [...messages.values()];
}
